
interface LaunchInfoProps {
  launch: {
    jotform_form_mappings?: { form_title: string; jotform_form_id: string } | null;
    clientes?: { nombre: string } | null;
    report_templates?: { name: string } | null;
    report_templates_v2?: { name: string } | null;
    max_respuestas: number | null;
    report_lifetime: number | null;
    created_at: string | null;
  };
  reportLifetimeDays: number | null;
}

export const LaunchInfo = ({ launch, reportLifetimeDays }: LaunchInfoProps) => {
  // Helper function for formatting dates
  const formatDate = (dateString: string | null) => {
    if (!dateString) return "No definida";
    return new Date(dateString).toLocaleDateString();
  };

  // Get form name from jotform_form_mappings
  const formName = launch.jotform_form_mappings?.form_title ||
                   launch.jotform_form_mappings?.jotform_form_id ||
                   "N/A";

  // Get template name (V2 has priority)
  const templateName = launch.report_templates_v2?.name ||
                       launch.report_templates?.name ||
                       "N/A";

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <h3 className="font-medium mb-1">Formulario</h3>
        <p>{formName}</p>
      </div>
      <div>
        <h3 className="font-medium mb-1">Cliente</h3>
        <p>{launch.clientes?.nombre || "N/A"}</p>
      </div>
      <div>
        <h3 className="font-medium mb-1">Plantilla</h3>
        <p>{templateName}</p>
      </div>
      <div>
        <h3 className="font-medium mb-1">Máx. Respuestas por código</h3>
        <p>{launch.max_respuestas || "Sin límite"}</p>
      </div>
      <div>
        <h3 className="font-medium mb-1">Tiempo de Vida del Reporte</h3>
        <p>
          {reportLifetimeDays ? `${reportLifetimeDays} días` : "Sin expiración"}
        </p>
      </div>
      <div>
        <h3 className="font-medium mb-1">Fecha de Creación</h3>
        <p>{formatDate(launch.created_at)}</p>
      </div>
    </div>
  );
};
